import { useMutation, DefaultError, useQueryClient } from '@tanstack/react-query';

import { JobRepository } from 'domain/repositories/IJobRepository';
import { ID } from 'domain/types/ID';
import { useHookInjection } from 'application/hooks';

import { QUERY_PREFIX } from './useCaseSearchCustomerJobs';

export interface CancelCustomerJobRequestParams {
  jobRequestId: ID;
}

export const useCaseCancelCustomerJobRequest = () => {
  const { cancelCustomerJobRequest } = useHookInjection<JobRepository>(JobRepository);
  const queryClient = useQueryClient();

  const { mutateAsync, isPending, isError, error } = useMutation<
    void,
    DefaultError,
    CancelCustomerJobRequestParams
  >({
    mutationFn: cancelCustomerJobRequest,
    onSuccess: () => {
      // Invalidate the customer jobs query to refresh the list after cancellation
      queryClient.invalidateQueries({ queryKey: [QUERY_PREFIX] });
    },
  });

  return {
    cancelCustomerJobRequest: mutateAsync,
    isLoading: isPending,
    isError,
    error,
  };
};
